export { default } from './AllTariffs';
